import React from "react"

import { getFormattedMessage, isLTPM } from "../../components/shared_components_registration"

export const API_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
  FAILED: "failed",
  IDLING: "idling", // Placeholder status
}

export const listUtils = {
  removeDuplicates: (arr) => {
    const s = new Set(arr)
    return [...s].sort()
  },
}

export const Required = () => {
  return <span className={"required-message"}>*</span>
}

const registration = {
  runLabel: (intl) =>
    isLTPM
      ? intl.formatMessage({ id: "fermmanagement.inoculum.run", defaultMessage: "Run Parent(s)" })
      : "Run Parent(s)",
  biocatLabel: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "fermmanagement.inoculum.biocatalyst",
          defaultMessage: "Biocatalyst Parent(s)",
        })
      : "Biocatalyst Parent(s)",
  extSmpLabel: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "fermmanagement.inoculum.external.sample",
          defaultMessage: "External Sample Parent(s)",
        })
      : "External Sample Parent(s)",
  extRunLabel: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "fermmanagement.inoculum.external.run",
          defaultMessage: "External Run Parent(s)",
        })
      : "External Run Parent(s)",
}

export const infoContent = (runID, run, intl) => {
  const { runParents = [], bioCatalystParents = [], externalRuns = [], externalSamples = [] } = run
  const bioCatalystParentsStr =
    bioCatalystParents?.length > 0
      ? bioCatalystParents.map((p) => `${p.count} '${p.uom}' of ${p.name} (lot: ${p.lot_no})`).join(", ")
      : ""
  const externalRunsStr =
    externalRuns?.length > 0 ? externalRuns.map((p) => `${p.name} [${p.name_source}]`).join(", ") : ""
  const externalSamplesStr =
    externalSamples?.length > 0 ? externalSamples.map((p) => `${p.name} [${p.name_source}]`).join(", ") : ""

  return (
    <>
      <span>Ref id: {runID}</span>
      <div>
        {runParents?.length > 0 && (
          <span>
            <br />
            {registration.runLabel(intl)}:
            {runParents.map((runParent, idx) => (
              <span key={idx} className="white-text-parent">
                {Object.entries(runParent).map(([site, reactor]) => (
                  <span key={site}>
                    {" "}
                    {site}: {reactor}
                  </span>
                ))}
              </span>
            ))}
          </span>
        )}
        {bioCatalystParentsStr && (
          <span>
            <br />
            {registration.biocatLabel(intl)}: <br />
            {bioCatalystParentsStr}
          </span>
        )}
        {externalRunsStr && (
          <span>
            <br />
            {registration.extRunLabel(intl)}:
            <br /> {externalRunsStr}
          </span>
        )}
        {externalSamplesStr && (
          <span>
            <br />
            {registration.extSmpLabel(intl)}:
            <br /> {externalSamplesStr}
          </span>
        )}
        {run?.missing_parental_information && ( // LTPM concept
          <span>
            <br />*
            {getFormattedMessage(
              "fermmanagement.missing.inoculation.warn.msg",
              "This run has not been inoculated yet",
            )}
          </span>
        )}
      </div>
    </>
  )
}
